module.exports = __webpack_public_path__ + "static/media/add-favorite.cf6cec09.svg";